<template>
  <div class="bpm-business-addr">
    <!-- Put this feature on the top in new design-->
    <ttr-tax-exemption
      :selected-country="form.country"
      :account="account"
      :tracking="tracking"
      v-on="$listeners">
    </ttr-tax-exemption>
    <zm-checkbox
      v-if="!hasZPPlan && showBusinessTypeCheckBox"
      :value="isBusinessType"
      name="usageType"
      prop="usageType"
      @change="changeUsageType"
    >{{__$t('billing.addr.biz_info')}}</zm-checkbox>
    <!-- Is For Edu Begin -->
    <zm-checkbox
        class="bpm-business-addr__edu-checkbox"
      :value="isForEdu"
      name="isForEdu"
      @change="isForEduChange"
      v-if="isShowEduCoppa"
    >{{ __$t("billing.addr.for_edu.tip") }}</zm-checkbox>
    <div class="empty-div" style="margin-top: 13px" v-if="hasZPPlan"></div>
    <template v-if="isForEdu">
      <zm-form-item
        label=""
        class="bpm-addr__required text-capitalize-form-item"
        prop="coppa"
        for="coppa"
        style="padding-left:25px;"
        :aria-label="__$t('billing.addr.for_edu.select_apply')+',required'"
      >
        <label tabindex="0" :aria-label="__$t('billing.addr.for_edu.select_apply')+',required'">{{ __$t('billing.addr.for_edu.select_apply') }}</label>
        <zm-checkbox-group v-model="coppa" @change="onEduAgeGroupChange">
          <zm-checkbox :label="EDUCATION_AGE_GROUP.UNDER_13" :aria-label="__$t('billing.addr.for_edu.under_13')" @change="v=>sendGaCheck(v,'under_13')">{{__$t('billing.addr.for_edu.under_13')}}</zm-checkbox>
          <zm-checkbox :label="EDUCATION_AGE_GROUP.RANGE_13_TO_15" :aria-label="__$t('billing.addr.for_edu.range_n_m', [13, 15])" @change="v=>sendGaCheck(v,'13_to_15')">{{__$t('billing.addr.for_edu.range_n_m', [13, 15])}}</zm-checkbox>
          <zm-checkbox :label="EDUCATION_AGE_GROUP.RANGE_16_TO_17" :aria-label="__$t('billing.addr.for_edu.range_n_m', [16, 17])" @change="v=>sendGaCheck(v,'16_to_17')">{{__$t('billing.addr.for_edu.range_n_m', [16, 17])}}</zm-checkbox>
        </zm-checkbox-group>
      </zm-form-item>
    </template>
    <!-- Is For Edu End -->
    <template v-if="isBusinessType">
      <zm-form-item
        :label="__$t('billing.company_organization_legal')"
        class="bpm-addr__required text-capitalize-form-item"
        ref="companyName"
        prop="companyName"
        for="company-name"
        aria-label="required"
      >
        <zm-input v-model="form.companyName" id="company-name" />
      </zm-form-item>
      <div
        v-if="!showDoingBusiness"
        class="bpm-addr__add-adress text-capitalize-form-item"
        @click="displayDoingBusiness"
        tabindex="0"
        :aria-label="'add '+ __$t('billing.addr.doing_biz_as_name')"
        role="button"
        :label="'add '+__$t('billing.addr.doing_biz_as_name')"
      >+ {{__$t('billing.addr.doing_biz_as_name')}}</div>
      <zm-form-item
        v-if="showDoingBusiness"
        :label="__$t('billing.addr.doing_biz_as_name')"
        class="text-capitalize-form-item"
        ref="doingBusinessAsName"
        prop="doingBusinessAsName"
        for="doing-biz-as-name"
      >
        <div class="bpm-business-addr__bizname">
          <zm-input v-model="form.doingBusinessAsName" class="tooltip-input" id="doing-biz-as-name" ref="doingBusinessAsNameInput" />
          <zm-tooltip class="item" :content="__$t('billing.addr.doing_biz_as_name_tips')" placement="bottom"
            :aria-label="'learn more about Doing Business As Company Name'">
            <i class="bpm-addr-tip zm-icon-info-outline" />
          </zm-tooltip>
        </div>
      </zm-form-item>
      <zm-form-item
        :label="__$t('billing.addr.business_size')"
        size="xLarge"
        class="bpm-addr__required text-capitalize-form-item"
        ref="employeeCount"
        prop="employeeCount"
        for="employee-count"
        aria-label="required"
        v-if="showBusinessSize"
      >
        <zm-select filterable v-model="form.employeeCount" :popper-append-to-body="true" @focus="disableGoogleAuto"
        :label="__$t('billing.addr.business_size')"
        >
          <zm-option
            v-for="item in employeeCountList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            id="employee-count"
          ></zm-option>
        </zm-select>
      </zm-form-item>
    </template>
    <template v-else-if="isForEdu">
      <zm-form-item
        :label="__$t('billing.addr.org_name')"
        class="bpm-addr__required text-capitalize-form-item"
        ref="orgName"
        prop="orgName"
        for="org-name"
        aria-label="required"
      >
        <zm-input v-model="form.orgName" id="org-name" />
      </zm-form-item>
      <zm-form-item
        :label="__$t('billing.addr.org_size')"
        size="xLarge"
        class="bpm-addr__required text-capitalize-form-item"
        ref="orgCount"
        prop="orgCount"
        for="org-count"
        aria-label="required"
      >
        <zm-select filterable v-model="form.orgCount" :popper-append-to-body="true"
        :label="__$t('billing.addr.org_size')">
          <zm-option
            v-for="item in employeeCountList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            id="org-count"
          ></zm-option>
        </zm-select>
      </zm-form-item>
    </template>

    <zm-form-item
      :label="__$t('billing.addr.hq')"
      size="xLarge"
      prop="accountHq"
      for="account-hq"
      class="bpm-addr__required text-capitalize-form-item"
      aria-label="required"
      v-if="isBusinessType"
    >
      <zm-select id="account-hq" filterable v-model="form.accountHq" :popper-append-to-body="true"  @focus="disableGoogleAuto"  :aria-label="__$t('billing.addr.hq')+',required'"
      :label="__$t('billing.addr.hq')">
        <zm-option
          v-for="(country, index) in countryList"
          :key="index"
          :label="country.label"
          :value="country.value"
        ></zm-option>
      </zm-select>
    </zm-form-item>
    <business-form-rps v-if="isBusinessType" :form="form"/>
  </div>
</template>

<script>
import formMixins from './mixins/form-mixin.js';
import TtrTaxExemption from "./ttr-tax-exemption.vue";
import businessFormRps from "./business-form-rps.vue";
import { computedPbxPlans } from '../../utils/pbx';
import { planTypes, flowTypes } from '../../common/constant';
import {APP_NAMESPACE} from "../../store";
import trackingMixin from "../mixins/trackingMixin";
import {mapGetters} from "vuex";

const EDUCATION_AGE_GROUP = {
  UNDER_13: 1,
  RANGE_13_TO_15: 2,
  RANGE_16_TO_17: 4,
}
export default {
  name: 'businessForm',
  components: {TtrTaxExemption, businessFormRps},
  mixins: [formMixins, trackingMixin],
  props: {
    tracking: Function,
    form: {
      type: Object,
    },
    pageConfigType: {
      type: String,
      default: ''
    },
    isLoggedIn: {
      type: Boolean,
      require: true
    },
    isBizPlusContext: {
      type: Boolean,
      require: true
    },
    account: {
      type: Object,
    },
    showBusinessTypeCheckBox: {
      type: Boolean,
      default: true
    },
    showBusinessSize: {
      type: Boolean,
      default: true
    },
    isShowEduCoppa: {
      type: Boolean,
      default: false
    },
    hasZPPlan: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      showDoingBusiness: false,
      employeeCountList: [
        {
          value: 'Just Me',
          label: this.__$t('billing.just_me'),
        },
        {
          value: '2-10',
          label: '2-10',
        },
        {
          value: '11-50',
          label: '11-50',
        },
        {
          value: '51-250',
          label: '51-250',
        },
        {
          value: '251-500',
          label: '251-500',
        },
        {
          value: '501-1000',
          label: '501-1000',
        },
        {
          value: '1001-5000',
          label: '1001-5000',
        },
        {
          value: '5001-10000',
          label: '5001-10000',
        },
        {
          value: '10001+',
          label: '10001+',
        },
      ],
      eligibleForTtrTaxExemption: false,
      coppa: [],
      isForEdu: false,
      EDUCATION_AGE_GROUP,
    };
  },
  computed: {
    ...mapGetters(APP_NAMESPACE, ['countryList', 'addressInfo']),
    isBusinessType () {
      return this.form.usageType ==='business' || this.isBizPlusContext
    }
  },
  methods: {
    displayDoingBusiness() {
      this.showDoingBusiness = true;
      this.$nextTick(()=>{
        this.$refs['doingBusinessAsNameInput'].focus()
      })
    },
    changeUsageType(v) {
      this.$emit('changeUsageType', v);
      this.emitTracking('changeUsageType', v)
    },
    isForEduChange(isForEdu) {
      this.isForEdu = isForEdu;
      this.$emit('changeEdu', {isForEdu});
      this.emitTracking('isForEduChange', isForEdu)
    },
    onEduAgeGroupChange (coppa) {
      this.$emit('changeEdu', {coppa});
    },
    sendGaCheck(v,age){
      this.emitTracking('sendGaCheck', v, age)
    },
    disableGoogleAuto(e){
      try{
        e.target.autocomplete = 'nope'
      }catch(e){
        // do nothing
      }
    }
  },
  watch: {
    'form.doingBusinessAsName': {
      immediate: true,
      handler(value) {
        if (value && value.trim() !== '') {
          this.showDoingBusiness = true
        }
      }
    },
    'form.coppa': {
      immediate: true,
      handler (coppaArr) {
        if(Array.isArray(coppaArr))
        this.coppa = coppaArr;
      }
    },
    'form.isForEdu':{
      immediate: true,
      handler (v) {
        this.isForEdu = !!v;
      }
    },
    'isShowEduCoppa':{
      immediate: true,
      handler (v) {
        // If hide the show edu option, must clear the already checked status in form data.
        if(!v) this.isForEdu = false;
      }
    },
    'form.country':{
      immediate: true,
      handler (v) {
        if(!this.form.accountHq){
           this.form.accountHq = v
        }
      }
    }
  }
};
</script>
<style lang="scss">
.tooltip-input {
  width: 95%;
}

.bpm-business-addr {
  &__spacer {
    margin-top: 0;
  }

  &__edu-checkbox {
    margin: 0;
  }

  &__bizname{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
